export const removeControlCharacters = (str: string) =>
  // eslint-disable-next-line no-control-regex
  str.replace(/[\u0000-\u001F\u007F-\u009F\\]/g, '')
